import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms'; // Added Validators
import { Observable, finalize } from 'rxjs';
import { UserMasterReadAllPaginatedRequest } from 'src/app/Admin/user-master/user-master.interface';
import { CompanyMasterReadByUserIdRequestDTO } from 'src/app/AdvERP/companies/companies.interface';
import { CompaniesService } from 'src/app/AdvERP/companies/companies.service';
import { SoftwareMasterGetDictionaryRequestDTO } from 'src/app/AdvERP/software-master/software-master.interface';
import { SoftwareMasterService } from 'src/app/AdvERP/software-master/software-master.service';
import { BranchMasterReadByUserIdRequestDTO } from 'src/app/Common/BranchMasterService/branchmaster.interface';
import { BranchMasterService } from 'src/app/Common/BranchMasterService/branchmaster.service';
import { GetDictionaryDTO } from 'src/app/Common/common.interface';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { UserPermissionService } from 'src/app/Common/UserPermission/userPermission.service';
import { ValueListService } from 'src/app/Common/ValueListService/value-list.service';

@Component({
  selector: 'app-company-branch-software-select',
  templateUrl: './company-branch-software-select.component.html',
  styleUrls: ['./company-branch-software-select.component.css']
})
export class CompanyBranchSoftwareSelectComponent implements OnInit {

  showBranchDropdown: boolean = true;
  @Input() unitForm!: FormGroup
  @Input() showLabels: boolean = false; // opt-in: shows a small label above each dropdown
  @Output() selectionChanged = new EventEmitter<UserMasterReadAllPaginatedRequest>();
  @Output() loadingChange = new EventEmitter<boolean>();

  userPermissionService = inject(UserPermissionService);
  valuelist = inject(ValueListService)
  companyService = inject(CompaniesService);
  branchMasterService = inject(BranchMasterService);

  softwareMasterService = inject(SoftwareMasterService);
  companyList: GetDictionaryDTO[] = [];
  branchList: GetDictionaryDTO[] = [];
  softwareList: GetDictionaryDTO[] = [];
  private pendingLoads = 0;
  get isLoading(): boolean { return this.pendingLoads > 0; }

  User = inject(UserLoginService).User()

  ngOnInit(): void {
    this.getBranchConfig();
    this.getCompanyList();
    this.getSoftwareList();
  }

  get tenantIdControl(): FormControl {
    return this.unitForm.get('tenantId') as FormControl;
  }

  get tenantBranchIdControl(): FormControl {
    return this.unitForm.get('tenantBranchId') as FormControl;
  }

  get softwareIdControl(): FormControl {
    return this.unitForm.get('softwareId') as FormControl;
  }

  getBranchConfig() {

    this.track(this.valuelist.ValueListItem_readByVlCode({
      vlCode: 'BD',
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId
    })).subscribe({
      next: (res) => {

        let configValue = '';

        if (res && res.items && res.items.length > 0) {
          configValue = (res.items[0].vliCode || '').trim().toUpperCase();
        }

        // HIDE => hide dropdown
        // anything else => show dropdown
        this.showBranchDropdown = configValue !== '0';

        this.getCompanyList();
      },

      error: () => {
        this.showBranchDropdown = true;
        this.getCompanyList();
      }
    });
  }

  private emitLoading() {
    // deferred so a parent binding is not changed mid change-detection
    Promise.resolve().then(() => this.loadingChange.emit(this.isLoading));
  }

  private track<T>(source: Observable<T>): Observable<T> {
    this.pendingLoads++;
    this.emitLoading();
    return source.pipe(finalize(() => { this.pendingLoads--; this.emitLoading(); }));
  }
  onCompanyChange() {
    this.getBranchList(this.tenantIdControl.value as number);
  }

  getCompanyList() {
    let req: CompanyMasterReadByUserIdRequestDTO = {
      actionUser: this.User.userId.toString()
    }

    this.track(this.companyService.CompanyMaster_GetDictionary(req)).subscribe((res) => {
      this.companyList = res.dropDownList;
      this.tenantIdControl.setValue(+this.User.companyId);
      this.onCompanyChange();
    })
  }

  getBranchList(companyId: number) {

    let req: BranchMasterReadByUserIdRequestDTO = {
      tenantId: companyId,
      actionUser: this.User.userId.toString()
    }

    this.track(this.branchMasterService.BranchMaster_GetDictionary(req)).subscribe((res) => {
      this.branchList = res.dropDownList;
      if (this.branchList.length > 0) {

        if (this.tenantIdControl.value == this.User.companyId) {
          this.tenantBranchIdControl.setValue(this.User.loggedInBranchId);
        } else {
          const onlyBranchId = parseInt(this.branchList[0].key);
          this.tenantBranchIdControl.setValue(onlyBranchId);
        }

      } else {
        this.tenantBranchIdControl.setValue(0);
      }

    })
  }

  getSoftwareList() {
    let req: SoftwareMasterGetDictionaryRequestDTO = {
    }
    this.track(this.softwareMasterService.SoftwareMaster_GetDictionary(req)).subscribe((res) => {
      this.softwareList = res.dropDownList;
      if (this.softwareList.length > 0) {
        this.softwareIdControl.setValue(parseInt(this.softwareList[0].key));
      } else {
        this.softwareIdControl.setValue(0);
      }
    })
  }

  submit() {
    this.selectionChanged.emit()
  }
}
